<template>
  <div class="row list">
    <div class="col-lg-12 col-md-12">
      <div class="card m-b-30">
        <div class="card-body">
          {{ clients.total }} Duplicate ID Cards.
          <button class="btn btn-info" @click="getClients">Query</button>
          <div class="table-responsive">
            <table class="table align-td-middle table-card">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Phone Number</th>
                  <th>Type</th>
                  <th>ID card</th>
                  <th>Sector</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="client in clients.data" v-bind:key="client.id">
                  <td>
                    <router-link
                      :to="{ path: '/client/' + client.id, params: {} }"
                    >
                      {{ client.firstname }} {{ client.lastname }}
                      {{ client.id }} ({{ client.type }})
                    </router-link>
                  </td>
                  <td>{{ client.phone_number }}</td>
                  <td>{{ client.type }}</td>
                  <td>
                    {{ client.id_card_number }}
                  </td>
                  <td>
                    {{ client.sector }}
                  </td>
                  <td>
                    <button
                      type="button"
                      @click="changeNumber(client)"
                      class="btn btn-primary"
                      style="margin-left: 10px; margin-top: 10px"
                    >
                      <i class="fe fe-edit"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        loader="dots"
        :can-cancel="false"
        :is-full-page="fullPage"
      ></loading>
    </div>
  </div>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      states: "",
      clients: "",
    };
  },

  methods: {
    getClients() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/duplicate_id_card_number/90`)
        .then((response) => {
          this.clients = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    changeNumber(client) {
      this.isLoading = true;
      this.axios
        .patch(`/api/v1/auth/id-card-number/change/${client.id}`, {
          type: client.type,
        })
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          // this.getClients()
          this.$toasted.success("Changed Successfully", {
            position: "top-center",
            duration: 3000,
          });
        })
        .catch((error) => {
          console.error(error);
          this.$toasted.error("Not Found!", {
            position: "top-center",
            duration: 3000,
          });
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getClients();
  },
};
</script>
